import React from 'react';
import { USDollar, colors } from '/src/utilities/formats';

const BarChart = ({
    data,
    total,
    color = null,
    currency = false
}) => {
    if (!data) return null;

    if (!color) {
        color = colors.blue;
    }

    return (
        <div>
            <div className='d-flex justify-content-between align-items-center'>
                <p className='mb-0'><strong>{data.label}</strong></p>
                <p className='mb-0'>{!currency ? data.value : USDollar.format(data.value)}</p>
            </div>
            <div
                style={{
                    background: `linear-gradient(to right, ${color} ${(data.value / total) * 100}%, #E8EEF1 ${(data.value / total)}%)`,
                    height: '20px',
                }}
            >
            </div>
        </div>
    );
};

export default BarChart;